module.exports = {"450902001":"玉城街道","450902002":"南江街道","450902003":"城西街道","450902004":"城北街道","450902005":"名山街道","450902100":"大塘镇","450902105":"茂林镇","450902106":"仁东镇","450902113":"仁厚镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450902.json
// module id = 2261
// module chunks = 0